//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { IReferenceType, IOpChangeState, IJsonSerializable } from '../util/interfaces'
import { Enums } from '../common/enums'
import { DataProvider } from '../../helpers/data-provider'
import { OpDescr } from './op-descr'

export class OpPriority implements IReferenceType, IOpChangeState, IJsonSerializable {
    public idPriority: number
    public value: number
    public idDescr: number
    public descr: OpDescr

    constructor(opObj: any) {
         this.fromJSON(opObj)
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end
    //IReferenceType implementation
    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdPriority
    }
    public getReferenceKey(): number {
        return this.idPriority
    }
    public getReferenceValue(): any {
        return this
    }
    //IReferenceType implementation end

    
    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            if (compressed || (opObj && opObj.__IC && opObj.__IC == 1)) {
                this.idPriority = opObj.IP
                this.value = opObj.V
                this.idDescr = opObj.I
                this.descr = opObj.D ? new OpDescr(opObj.D) : null
                this.opState = opObj.O
            } else {
                this.idPriority = opObj.ID_PRIORITY
                this.value = opObj.VALUE
                this.idDescr = opObj.ID_DESCR
                this.descr = opObj._Descr ? new OpDescr(opObj._Descr) : null
                this.opState = opObj.OpState
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            return {
                IP: this.idPriority,
                V: this.value,
                I: this.idDescr,
                D: this.descr != null ? this.descr.toJSON(compressed) : null,
                O: this.opState,
                __IC: 1
            }
        } else {
            return {
                ID_PRIORITY: this.idPriority,
                VALUE: this.value,
                ID_DESCR: this.idDescr,
                _Descr: this.descr != null ? this.descr.toJSON(compressed) : null,
                OpState: this.opState
            }
        }
    }

    public toString(): string {
        if (this.descr)
            return '(' + this.value + ') ' + this.descr.description 
        else
            return this.value + ''
    }

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpPriority[]): JQueryPromise<OpPriority[]> {
        var defered = $.Deferred<OpPriority[]>()

        defered.resolve(list)

        return defered.promise()
    }

}